import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
// const triggerElement = document.querySelector(".spacer");


setScrollBanner();

// Select banners and set up sticky behavior
function setScrollBanner(){
  const banners = gsap.utils.toArray(".banner");
  banners.forEach((banner, i) => {

    const isLast = i === banners.length - 1;
  
    ScrollTrigger.create({
      trigger: banner, // Each banner as its own trigger
      start: "top top+=172", // Start when the banner reaches the center
      end: isLast
          ? () => { 
            // Dynamic end: get number if listings found
            const containers = document.querySelectorAll('div[id^="listing-card-"]').length; 
            if(containers > 15){
              return `${(containers - 10) * 200}px top`; // approximately because one listing card is almost 230px high
            }
            else{
              return "bottom top";
            }
          }
          : "bottom", // End after the banner scrolls out but for the last one, extend end way down
      pin: true, // Enable sticky behavior
      pinSpacing: true,
      animation: ScrollTrigger.animation,
      onEnter: () => banner.classList.add("active"),
      onLeaveBack: () => banner.classList.remove("active"),
      onLeave: () => {
        // Prevent last one from unpinning on scroll down
        if (isLast) ScrollTrigger.refresh();
      },
      markers: false
  
    });
  
    // Apply the sticky top offset via CSS
    gsap.set(banner, {
      position: "sticky",
      top: "172px",
    });
  });
}

document.addEventListener("searchListingMade", () => {  
  // Kill all previous scroll triggers first
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  // Reinitialize your banner scroll logic
  setScrollBanner(); // This should contain your ScrollTrigger.create code

  // Refresh after reinitialization
  ScrollTrigger.refresh(); 
});